module.exports = __webpack_public_path__ + "img/1-5.ea9b1db5.png";